import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface RelatedFeature {
  icon: LucideIcon;
  title: string;
  description: string;
  link: string;
}

interface RelatedFeaturesSectionProps {
  features: RelatedFeature[];
}

const RelatedFeaturesSection = ({ features }: RelatedFeaturesSectionProps) => {
  return (
    <section className="mb-20">
      <h2 className="text-3xl font-bold text-center mb-4">Related Features</h2>
      <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
        Discover other powerful capabilities that work seamlessly with this feature
      </p>
      <div className="grid md:grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <Card key={index} className="p-6 hover:shadow-lg transition-all hover:border-primary/50 group">
            <div className="mb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <feature.icon className="h-6 w-6 text-primary" />
              </div>
            </div>
            <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{feature.description}</p>
            <Button variant="link" className="p-0 h-auto" asChild>
              <Link to={feature.link}>
                Learn more <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default RelatedFeaturesSection;
